import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { Modal } from "../../submodules/rapdv/client/elements/Bootstrap"

export class PanelSelectPlan implements ClientPage {
  private static readonly PLAN_TIERS: Record<string, number> = {
    starter: 1,
    basic: 2,
    business: 3,
  }

  private downgradeModal: Modal | null = null
  private pendingPlan: string = ""

  getPageId = (): string => "select-plan-panel"

  execute = (): void => {
    this.setupDowngradeModal()
  }

  onPageClose = (): void => {}

  private setupDowngradeModal = (): void => {
    const formEl = document.getElementById("select-plan-form") as HTMLFormElement
    if (!formEl) return

    const modalEl = document.getElementById("downgrade-confirm-modal")
    if (!modalEl) return

    const currentPlan = formEl.dataset.currentPlan ?? ""
    const currentTier = PanelSelectPlan.PLAN_TIERS[currentPlan] ?? 0
    if (currentTier === 0) return

    this.downgradeModal = new Modal(modalEl)

    formEl.querySelectorAll<HTMLButtonElement>('button[name="licenseType"]').forEach((btn) => {
      const newPlan = btn.value
      const newTier = PanelSelectPlan.PLAN_TIERS[newPlan] ?? 0

      if (newTier < currentTier) {
        btn.addEventListener("click", (event) => {
          event.preventDefault()
          this.pendingPlan = newPlan

          const loseMultipleUsers = modalEl.querySelector<HTMLElement>("[data-lose-multiple-users]")
          const loseOrdering = modalEl.querySelector<HTMLElement>("[data-lose-ordering]")

          if (loseMultipleUsers) {
            loseMultipleUsers.style.display = currentPlan === "business" ? "" : "none"
          }
          if (loseOrdering) {
            loseOrdering.style.display = newPlan === "starter" ? "" : "none"
          }

          this.downgradeModal?.show()
        })
      }
    })

    const confirmBtn = modalEl.querySelector<HTMLElement>('[data-action="confirm-downgrade"]')
    confirmBtn?.addEventListener("click", () => {
      const hiddenInput = document.createElement("input")
      hiddenInput.type = "hidden"
      hiddenInput.name = "licenseType"
      hiddenInput.value = this.pendingPlan
      formEl.appendChild(hiddenInput)
      this.downgradeModal?.hide()
      formEl.submit()
    })
  }
}
